module.exports = __webpack_public_path__ + "static/img/gongsi.a4621cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/us/gongsi.png
// module id = ImXg
// module chunks = 1 2